import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { authServices } from "../APIServices/UserData/authServices";

const SetupPrimaryAccount = ({
  setNextStep,
  setName,
  name,
  setEmail,
  email,
  setLoader,
  loader
}) => {
  const [accountName, setAccountName] = useState("");
  const [description, setDescription] = useState("");

  const setUpAccount = async () => {
    setLoader(true)
    let userData = {}
    userData.accountName = accountName
    userData.description = description
    userData.email = email
    userData.name = name
    let data = await authServices.setUpAccount(userData)
    if (data?.statusCode === 200) {
      setNextStep(data?.status)
      setName(data?.name)
      setEmail(data?.email)
      setAccountName("")
      setDescription("")
    }
    setLoader(false)
  }
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Account Name</Form.Label>
        <Form.Control
          onChange={(e) => setAccountName(e.target.value)}
          value={accountName}
          className="form-input"
          placeholder="Enter Account name"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Description</Form.Label>
        <Form.Control
          onChange={(e) => setDescription(e.target.value)}
          value={description}
          as="textarea"
          className="form-input"
          placeholder="Enter Description name"
        />
      </Form.Group>
      <div className="hstack gap-2">
        <Button
          disabled={loader || !accountName}
          className="w-100 btn-primary"
          onClick={setUpAccount}>
          Save & Continue
        </Button>
      </div>
    </>
  );
};

export default SetupPrimaryAccount;
